module.exports = __webpack_public_path__ + "static/media/armor-downgrade.71dd2b83.svg";